import { useUserEntitlementsContext } from '../../context';

export const useUserSubscription = () => {
  return useUserEntitlementsContext();
};
